import React from 'react';
import { ThemeProvider } from 'styled-components';
import Button from './styled';
import ButtonEdgeProps, { ThemeProps } from './type';
import { Icon } from '@/presentation/components';

const data = () => ({
  bindZoom: {
    style: {
      width: '100%',
      padding: '10px 0',
      border: '1px solid #1A055D',
      color: '#1A055D',
      backgroundColorHover: '#E2DFFD',
      backgroundColorFocus: '#1A055D',
      backgroundColorActive: '#C6C0FC',
      colorFocus: '#ffffff',
      colorActive: '#1A055D'
    },
    name: 'Vincularme a Zoom',
    icon: true,
    nameIcon: 'external-link'
  },
  viewHistory: {
    style: {
      padding: '8px 16px 8px 24px',
      border: '1px solid #5B36F2',
      color: '#5B36F2',
      backgroundColorHover: '#E2DFFD',
      backgroundColorFocus: '#5b36f2',
      backgroundColorActive: '#c6c0fc',
      colorFocus: '#ffffff',
      colorActive: '#5b36f2',
      coloricon: '#5B36F2'
    },
    name: 'Ver historial',
    icon: true,
    nameIcon: 'arrow-right'
  },
  defaul: {
    style: {
      padding: '12px 0',
      color: '#5B36F2',
      border: '1px solid #5B36F2',
      backgroundColorHover: '#E2DFFD',
      backgroundColorFocus: '#1A055D',
      backgroundColorActive: '#ffffff',
      colorFocus: '#ffffff'
    },
    name: 'Ir a UTP+Class',
    icon: false
  }
});

const themes = (typeButton: string | undefined): ThemeProps => {
  const { bindZoom, viewHistory, defaul } = data();
  switch (typeButton) {
    case 'bindZoom':
      return bindZoom;
    case 'viewHistory':
      return viewHistory;
    default:
      return defaul;
  }
};

const ButtonEdge = ({ onClick, buttonType, tabIndex }: ButtonEdgeProps) => {
  const { style, name, icon, nameIcon } = themes(buttonType);
  return (
    <ThemeProvider theme={style}>
      <Button
        data-testid="cmp-button-edge"
        onClick={onClick}
        tabIndex={tabIndex}
      >
        {name}
        {icon && <Icon name={nameIcon} color="#1A055D" size={20} />}
      </Button>
    </ThemeProvider>
  );
};

export default ButtonEdge;
